import clsx from 'clsx'
import { executionsConst } from 'features/executions'
import { useMemo } from 'react'
import Select from 'react-select'
import { typo } from 'shared/styles'
import { DropdownIndicator } from 'shared/ui/CustomSelect/DropdownIndicator'

import { type SelectProps, useSelectLogic } from './hooks'
import css from './LibSelect.module.css'

const info = executionsConst.qualificationInfo

const OPTIONS = executionsConst.QUALIFICATIONS.map(qualification => ({
	...info[qualification],
	value: qualification
}))

export function LibSelect({
														className,
														contactId,
														entityId
													}: SelectProps) {
	const { current, isInProgress, isReady, update } = useSelectLogic({
		contactId,
		entityId
	})

	const selected = useMemo(
		() => OPTIONS.find(option => option.value === current) || null,
		[current]
	)

	return (
		<Select
			className={clsx(className, typo.caption, css.select)}
			classNames={{
				control: ({ isDisabled, isFocused, isMulti, menuIsOpen }) =>
					clsx(css.control, typo.caption, {
						[css.disabled]: isDisabled,
						[css.focused]: isFocused,
						[css.open]: menuIsOpen,
						[css.withTags]: isMulti
					}),
				dropdownIndicator: () => css.indicator,
				input: () => css.input,
				menu: () => css.menu,
				menuList: () => clsx(css.list, 'app-scroll-thin'),

				multiValue: () => css.multi,
				multiValueLabel: () => css.tag,
				multiValueRemove: () => css.remove,
				option: ({ isSelected }) =>
					clsx(css.option, {
						[css.selected]: isSelected
					}),
				singleValue: () => css.single,
				valueContainer: () => css.container
			}}
			components={{
				// @ts-ignore false
				DropdownIndicator,
				IndicatorSeparator: null
			}}
			formatOptionLabel={option => [
				<span className={css.emoji} key="e">
						<img alt={option.label} src={option.emoji} />
				</span>,
				option.label
			]}
			getOptionValue={option => option.value}
			isDisabled={!isReady && isInProgress}
			isLoading={isInProgress}
			isMulti={false}
			onChange={value => value && update(value.value)}
			options={OPTIONS}
			value={selected}
		/>
	)
}
